module.exports = __webpack_public_path__ + "img/thumb_18.aabe0e07.jpg";